import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import InviteAccept from "@/pages/InviteAccept";
import ChangePassword from "@/pages/ChangePassword";
import Users from "@/pages/Users";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Employees from "@/pages/Employees";
import TimeTracker from "@/pages/TimeTracker";
import Payroll from "@/pages/Payroll";
import PayrollDetail from "@/pages/PayrollDetail";
import Approvals from "@/pages/Approvals";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400" data-testid="auth-loading">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ChangePassword />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/invite/:token" element={<InviteAccept />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/users" element={<Protected><Users /></Protected>} />
            <Route path="/app/companies" element={<Protected><Companies /></Protected>} />
            <Route path="/app/employees" element={<Protected><Employees /></Protected>} />
            <Route path="/app/time" element={<Protected><TimeTracker /></Protected>} />
            <Route path="/app/payroll" element={<Protected><Payroll /></Protected>} />
            <Route path="/app/payroll/:id" element={<Protected><PayrollDetail /></Protected>} />
            <Route path="/app/approvals" element={<Protected><Approvals /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
